import React from 'react';
import { authRoles } from 'app/auth';

export const AccountConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.admin, //['admin', 'staff', 'user']
	routes: [
		{
			path: '/account-job/:useracount',
			component: React.lazy(() => import('./AccountJobDetailsApp'))
		},
		{
			path: '/account-cluster/:idCluster',
			component: React.lazy(() => import('./AccountClusterDetailsApp'))
		},
		{
			path: '/account',
			component: React.lazy(() => import('./AccountApp'))
		}
	]
};
